/**
 * @license ng-bs-daterangepicker v0.0.1
 * (c) 2013 Luis Farzati http://github.com/luisfarzati/ng-bs-daterangepicker
 * License: MIT
 */
(function (angular) {
'use strict';

angular.module('ngBootstrap', []).directive('input', ['$compile', '$parse', function ($compile, $parse) {
	return {
		restrict: 'E',
		require: '?ngModel',
		link: function ($scope, $element, $attributes, ngModel) {
			if ($attributes.type !== 'daterange' || ngModel === null ) return;

			var options = {};
			options.format = $attributes.format || 'YYYY-MM-DD';
			options.separator = $attributes.separator || ' - ';

		    //Remove escape quotes
		    var regex = new RegExp('\"','g');
		    if ($attributes.minDate && typeof $attributes.minDate == 'string')
		        $attributes.minDate = $attributes.minDate.replace(regex, '');
		    if ($attributes.maxDate && typeof $attributes.minDate == 'string')
		        $attributes.maxDate = $attributes.maxDate.replace(regex, '');

			options.minDate = $attributes.minDate && moment($attributes.minDate);
			options.maxDate = $attributes.maxDate && moment($attributes.maxDate);
			options.dateLimit = $attributes.limit && moment.duration.apply(this, $attributes.limit.split(' ').map(function (elem, index) { return index === 0 && parseInt(elem, 10) || elem; }) );
			options.ranges = $attributes.ranges && $parse($attributes.ranges)($scope);
			options.locale = $attributes.locale && $parse($attributes.locale)($scope);
			options.opens = $attributes.opens && $parse($attributes.opens)($scope);

			options.singleDatePicker = $attributes.singleDatePicker && $parse($attributes.singleDatePicker)($scope);
			options.timePicker = $attributes.timePicker && $parse($attributes.timePicker)($scope);
			options.timePickerIncrement = $attributes.timePickerIncrement && $parse($attributes.timePickerIncrement)($scope);
			options.timePicker12Hour = $attributes.timePicker12Hour && $parse($attributes.timePicker12Hour)($scope);

			function format(date) {
				return date.format(options.format);
			}

			function formatted(dates) {
				return [format(dates.startDate), format(dates.endDate)].join(options.separator);
			}

			ngModel.$formatters.unshift(function (modelValue) {
				if (!modelValue) return '';
				return modelValue;
			});

			ngModel.$parsers.unshift(function (viewValue) {
				return viewValue;
			});

			ngModel.$render = function () {
				if (!ngModel.$viewValue || !ngModel.$viewValue.startDate) return;
				$element.val(formatted(ngModel.$viewValue));
			};

			$scope.$watch($attributes.ngModel, function (modelValue) {
				if (!modelValue || (!modelValue.startDate)) {
					//ngModel.$setViewValue({ startDate: moment().startOf('day'), endDate: moment().startOf('day') });
					return;
				}
				$element.data('daterangepicker').startDate = modelValue.startDate;
				$element.data('daterangepicker').endDate = modelValue.endDate;
				$element.data('daterangepicker').updateView();
				$element.data('daterangepicker').updateCalendars();
				$element.data('daterangepicker').updateInputText();
			});

			var proto=$(document.createElement('div')).daterangepicker().data('daterangepicker').constructor.prototype;
			if (!proto.baseClickDate)
			    proto.baseClickDate = proto.clickDate;

			proto.clickDate = function (e) {
			    var endDate = this.endDate;
			    var cal = $(e.target).parents('.calendar');
			    this.baseClickDate(e);
			    if (cal.hasClass('left')) {
			        this.startDate = this.startDate.hour(9);
			        this.startDate = this.startDate.minute(0);
			    }
			    if (!cal.hasClass('left') ||  (cal.hasClass('left') && !this.endDate.isSame(endDate))) {
			        this.endDate = this.endDate.hour(18);
			        this.endDate = this.endDate.minute(0);
			    }
			    this.updateCalendars();
			};

		    proto.updateInputText = function () {
		        if (this.element.is('input') && !this.singleDatePicker) {
		            var start = this.startDate.format(this.format);
		            var end = this.endDate.format(this.format);
		            end = (start != end) ? this.separator + end : "";
		            this.element.val(start + end);
		        } else if (this.element.is('input')) {
		            this.element.val(this.endDate.format(this.format));
		        }
		    };

			$element.daterangepicker(options, function(start, end) {
				$scope.$apply(function () {
					ngModel.$setViewValue({ startDate: start, endDate: end });
					ngModel.$render();
				});
			});

		}
	};
}]);

})(angular);